/** Englische Fassungen für den Bereich „shell" (Schlüssel = deutscher Satz). */
export const EN_SHELL: Record<string, string> = {
  'Planen & Erstellen': 'Plan & create',
  'Planen · {phase}': 'Planning · {phase}',
  'Erstellen · {phase}': 'Creating · {phase}',
  'Startseite': 'Home',
  'Meta App Domains (ohne https:// und Pfad)': 'Meta App Domains (without https:// or path)',
  'In Meta → App-Einstellungen → Allgemein bei App Domains eintragen; die exakte URI oben zusätzlich unter Facebook Login → gültige OAuth-Redirect-URIs.': 'Enter this under Meta → App Settings → Basic → App Domains; also enter the exact URI above under Facebook Login → Valid OAuth Redirect URIs.',
  'Vorschau für Kanal': 'Preview for channel',
  'Die Plattform kann Bedienelemente und Zuschnitt leicht anders anzeigen.': 'The platform may show controls and cropping slightly differently.',
  'Follower-Zugriff fehlt': 'Follower access missing',
  'TikTok hat user.info.stats für diese Verbindung nicht freigegeben. Follower und Profil-Likes bleiben deshalb leer. Scope in der TikTok-Developer-App beantragen und danach neu verbinden.': 'TikTok has not granted user.info.stats for this connection. Follower and profile like counts remain unavailable. Request the scope in the TikTok developer app, then reconnect.',
  'Für echte Aufrufzahlen einzelner TikTok-Posts fehlt video.list. Scope freigeben und Konto neu verbinden.': 'video.list is needed for actual view counts of individual TikTok posts. Get the scope approved, then reconnect.',
  'Aktivität': 'Activity',
  '1 Beitrag wartet auf deine Freigabe': '1 post is waiting for your approval',
  '{n} Beiträge warten auf deine Freigabe': '{n} posts are waiting for your approval',
  '1 Beitrag wartet auf dich': '1 post is waiting for you',
  '{n} Beiträge warten auf dich': '{n} posts are waiting for you',
  '1 Entwurf wartet': '1 draft waiting',
  '{n} Entwürfe warten': '{n} drafts waiting',
  'Alles prüfen (alle Projekte)': 'Review everything (all projects)',
  'Alle Projekte ansehen': 'View all projects',
  'Ansehen →': 'View →',
  'Assistent fragen': 'Ask the assistant',
  'Automatik ist aus': 'Automation is off',
  'Automatik pausiert': 'Automation paused',
  'Baut gerade · {p} %': 'Building now · {p} %',
  'Beitrag': 'Post',
  'Dein Feed': 'Your feed',
  'Der Agent baut gerade · {p} %': 'The agent is building · {p} %',
  'Dunkles Design': 'Dark theme',
  'Helles Design': 'Light theme',
  'Erneuern': 'Renew',
  'Erstellen': 'Create',
  'Erweitert': 'Advanced',
  'Fehlgeschlagen': 'Failed',
  'Gerade arbeitet nichts.': 'Nothing is running right now.',
  'Jetzt prüfen →': 'Review now →',
  'Kalender': 'Calendar',
  'Kalender →': 'Calendar →',
  'Kein Kanal verbunden': 'No channel connected',
  'Kein Kanal verbunden, es kann nichts veröffentlicht werden': 'No channel connected, nothing can be published',
  'Lauf in {name}': 'Run in {name}',
  'Lernen': 'Learn',
  'Live ansehen →': 'Watch live →',
  'Läuft gerade': 'Running now',
  'Läuft von allein': 'Runs on its own',
  'Navigation': 'Navigation',
  'Neu bauen →': 'Rebuild →',
  'Nichts offen.': 'Nothing open.',
  'Nichts reserviert': 'Nothing reserved',
  'Noch nichts passiert.': 'Nothing has happened yet.',
  'Nächster Beitrag': 'Next post',
  'Pipeline': 'Pipeline',
  'Planen': 'Plan',
  'Rendern': 'Render',
  'So funktioniert\'s': 'How it works',
  'Teilweise': 'Partial',
  'Teilweise veröffentlicht': 'Partially published',
  'Tipps': 'Tips',
  'Verbinden': 'Connect',
  'Veröffentlichen': 'Publish',
  'Zuletzt': 'Recently',
  'alles geprüft': 'all reviewed',
  'arbeitet': 'working',
  'erzeugt Bilder': 'generating images',
  'legt Entwürfe ab': 'saving drafts',
  'nichts geplant': 'nothing scheduled',
  'nichts in Arbeit': 'nothing in progress',
  'noch kein Lauf': 'no run yet',
  'nächster {when}': 'next {when}',
  'plant gerade…': 'planning…',
  'postet gerade…': 'posting…',
  'sammelt Zahlen': 'collecting numbers',
  'schreibt Hooks und Texte': 'writing hooks and copy',
  'schätzt die Kosten': 'estimating costs',
  'wartet auf einen freien Platz': 'waiting for a free slot',
  'wählt Musik': 'picking music',
  '{done}/{total} Medien': '{done}/{total} media',
  '{n} Hooks fertig': '{n} hooks done',
  '{n} Lernregeln aktiv': '{n} learned rules active',
  '{n} Regeln': '{n} rules',
  '{n} vorab reserviert, Unverbrauchtes kommt zurück': '{n} reserved upfront, unused credits come back',
  '{n} rendert': '{n} rendering',
  '{n} warten auf dich': '{n} waiting for you',
  '{platform}-Zugang ist abgelaufen': '{platform} access has expired',
  '{platform}-Zugang läuft ab': '{platform} access expiring',
  '{platform}-Zugang läuft bald ab': '{platform} access expires soon',
  'Wird gebaut': 'Being built',
  'Wartet auf dich': 'Waiting for you',
  'Geplant': 'Scheduled',
  'Rendert': 'Rendering',
  'Wird gepostet': 'Posting',
  'Veröffentlicht': 'Published',
  'Verworfen': 'Discarded',
  'Baut': 'Building',
  'Prüfen': 'Review',
  'Postet': 'Posting',
  'Live': 'Live',
  'Fehler': 'Error',
  'Idee': 'Idea',
  'Einrichten': 'Set up',
  'Übersicht': 'Overview',
  'Automatik': 'Automation',
  'Rezepte': 'Recipes',
  'KI & Kanäle': 'AI & channels',
  'Lauf': 'Run',
  'Bearbeiten': 'Edit',
  'Alle Projekte': 'All projects',
  'Guthaben & Tarif': 'Credits & plan',
  'Konto': 'Account',
  'Aufladen': 'Top up',
  'Ausblenden': 'Hide',
  'Neues Projekt': 'New project',
  'Projekt': 'Project',
  'App': 'App',
  'Produkt': 'Product',
  'Unternehmen': 'Business',
  'Entwürfe kommen gleich': 'drafts coming soon',
  'noch nichts zu prüfen': 'nothing to review yet',
};
